import React, { useState, useEffect } from 'react';
import axios from 'axios';

const OutlateMaster = () => {
    const [outletData, setOutletData] = useState({
        Rest_Id: 0,
        Outlet_Name: '',
        isHoOutlate: false,
        Status: 'Active',
    });

    const [restaurants, setRestaurants] = useState([]);


    useEffect(() => {
        const fetchRestaurants = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_SERVER_API}restaurants`);
                setRestaurants(response.data);
            } catch (error) {
                console.log("Error fetching restaurants:", error);
            }
        };

        fetchRestaurants();
    }, []);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setOutletData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleHoOutlateChange = (e) => {
        setOutletData((prevState) => ({
            ...prevState,
            isHoOutlate: e.target.value === "true",
        }));
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${process.env.REACT_APP_SERVER_API}outlates`, outletData);
            console.log('Outlet Created Successfully:', response.data);


            alert("Outlet Created Successfully")


            setOutletData({
                Outlate_Id: 0,
                Rest_Id: 0,
                Outlet_Name: '',
                isHoOutlate: false,
                Status: 'Active',
            });
        } catch (error) {
            console.log('Error creating outlet:', error);
        }
    };




    return (
        <div className="container-fluid border p-3">

            <form onSubmit={handleSubmit}>


                {/* Outlet Name */}
                <div className="row ">
                    <div className="col-12 col-md-6 col-lg-4">
                        <input
                            type="text"
                            className="form-control"
                            name="Outlet_Name"
                            value={outletData.Outlet_Name}
                            onChange={handleInputChange}
                            placeholder="Outlet Name"
                            required
                        />
                    </div>
                </div>
                {/* Restaurant Selection */}
                <div className="row mt-4">
                    <div className="col-12 col-md-6 col-lg-4">
                        <select
                            className="form-control"
                            name="Rest_Id"
                            value={outletData.Rest_Id}
                            onChange={handleInputChange}
                            required
                        >
                            <option value={0} disabled>Select Restaurant</option>
                            {restaurants.map((restaurant) => (
                                <option key={restaurant._id} value={restaurant.Rest_Id}>
                                    {restaurant.Rest_Name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                {/* Is HoOutlate */}
                <div className="row mt-4">
                   
                    <div className="col-12 col-md-6 col-lg-4 d-flex">
                    <label class="form-label me-2">IsHoOutlate : </label>
                        <div className="form-check me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="yesHoOutlate"
                                name="isHoOutlate"
                                value={true}
                                checked={outletData.isHoOutlate === true}
                                onChange={handleHoOutlateChange}
                            />
                            <label className="form-check-label" htmlFor="yesHoOutlate">
                                Yes
                            </label>
                        </div>

                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="noHoOutlate"
                                name="isHoOutlate"
                                value={false}
                                checked={outletData.isHoOutlate === false}
                                onChange={handleHoOutlateChange}
                            />
                            <label className="form-check-label" htmlFor="noHoOutlate">
                                No
                            </label>
                        </div>
                    </div>
                </div>


                {/* Status */}
                <div className="row mt-4">
                    <div className="col-12 col-md-6 col-lg-4 d-flex">
                    <label class="form-label me-2">Status : </label>
                        <div className="form-check me-3">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="activeStatus"
                                name="Status"
                                value="Active"
                                checked={outletData.Status === 'Active'}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="activeStatus">
                                Active
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="radio"
                                id="inactiveStatus"
                                name="Status"
                                value="Inactive"
                                checked={outletData.Status === 'Inactive'}
                                onChange={handleInputChange}
                            />
                            <label className="form-check-label" htmlFor="inactiveStatus">
                                In-Active
                            </label>
                        </div>
                    </div>
                </div>

                {/* Submit Button */}
                <div className="row mt-3">
                    <div className="col-12 col-md-6 col-lg-4 justify-content-center">
                        <button type="submit" className="btn btn-primary">
                            Submit
                        </button>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default OutlateMaster;
